import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_Link;
const base = () => `${API_URL}/social-leads`;

const SocialLeadServices = {
  getLeads: (params) =>
    axios.get(base(), { params, headers: authHeader() }),

  getStats: (params) =>
    axios.get(base() + "/stats", { params, headers: authHeader() }),

  getOptions: (branchId) =>
    axios.get(base() + "/options", {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  addOption: (payload) =>
    axios.post(base() + "/options", payload, { headers: authHeader() }),

  getLead: (id) =>
    axios.get(base() + "/" + id, { headers: authHeader() }),

  createLead: (payload) =>
    axios.post(base(), payload, { headers: authHeader() }),

  updateLead: (id, payload) =>
    axios.put(base() + "/" + id, payload, { headers: authHeader() }),

  deleteLead: (id) =>
    axios.delete(base() + "/" + id, { headers: authHeader() }),
};

export default SocialLeadServices;
